import { __extends } from "tslib";
import { Component, Children } from 'react';
import PropTypes from 'prop-types';
var ChatConfigurationProvider = /** @class */ (function (_super) {
    __extends(ChatConfigurationProvider, _super);
    function ChatConfigurationProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatConfigurationProvider.prototype.getChildContext = function () {
        var _a = this.props, onImageMessageClick = _a.onImageMessageClick, onVideoMessageClick = _a.onVideoMessageClick, allowInput = _a.allowInput, disableAutoMessages = _a.disableAutoMessages;
        return {
            onImageMessageClick: onImageMessageClick,
            onVideoMessageClick: onVideoMessageClick,
            allowInput: allowInput,
            disableAutoMessages: disableAutoMessages,
        };
    };
    ChatConfigurationProvider.prototype.render = function () {
        return Children.only(this.props.children);
    };
    ChatConfigurationProvider.defaultProps = {
        disableAutoMessages: false,
    };
    ChatConfigurationProvider.childContextTypes = {
        onImageMessageClick: PropTypes.func,
        onVideoMessageClick: PropTypes.func,
        allowInput: PropTypes.bool,
        disableAutoMessages: PropTypes.bool,
    };
    return ChatConfigurationProvider;
}(Component));
export default ChatConfigurationProvider;
//# sourceMappingURL=ChatConfigurationProvider.js.map